import React from 'react';
import { smoothPath } from '../../charts.js';

const h = React.createElement;

/**
 * @param {object} p
 * @param {number[]} p.data
 * @param {number} [p.width]
 * @param {number} [p.height]
 * @param {string} [p.color]
 * @param {string} [p.label]
 */
export function Sparkline({ data = [], width = 96, height = 28, color = 'var(--ink)', label }) {
  if (data.length < 2) return null;
  const min = Math.min(...data), max = Math.max(...data), span = max - min || 1, p = 5;
  const pts = data.map((v, i) => [p + (i * (width - p * 2)) / (data.length - 1), p + (height - p * 2) * (1 - (v - min) / span)]);
  const last = pts[pts.length - 1];
  return h('svg', { width, height, viewBox: `0 0 ${width} ${height}`, role: label ? 'img' : undefined, 'aria-label': label, 'aria-hidden': label ? undefined : true, style: { display: 'block', overflow: 'visible' } },
    h('path', { d: smoothPath ? smoothPath(pts) : 'M' + pts.map((q) => q.join(',')).join('L'), fill: 'none', stroke: color, strokeWidth: 3, strokeLinejoin: 'round', strokeLinecap: 'round', className: 'gx-draw', pathLength: 1 }),
    h('circle', { cx: last[0], cy: last[1], r: 4.5, fill: 'var(--lime)', stroke: 'var(--ink)', strokeWidth: 2 }));
}
